module.exports = __webpack_public_path__ + "img/1.e5c86d15.jpg";